export class forumdetails
{
    text: string;
    noOfReplies: number;
    noofthumbsup: number;
    noofthumbsdown: number;
    userId: number;
    userName: string;
    datePosted:Date;
    longDatePostedString:string;
    dateoflastupdate:string;
    //parentUserId:number;
    parentcreateddate:Date;
    id:number;
    quoteID:number;
    moduleID:number;
    quoteSummary:string;
}

export class formquestions
{
    text:string;
}